export default __webpack_public_path__ + "static/media/aftersales_parts.ab1ac801.69897190.jpeg";